<template>
    <el-container class="h-full">
        <div class="h-screen bg-main my-top clearfix relative w-full overflow-hidden">

            <!-- Wave-->
            <div class="orc-wave"></div>

            <div class="w-full h-full p-0 absolute flex justify-center">
                <div class="self-center login-dialog">
                    <div class="text-center w-full mb-4"><h1 class="text-white text-3xl font-thin">Welkom terug!</h1>
                    </div>
                    <el-card shadow="always" class="orc-wave-blue mb-5">
                        <div class="mx-4 mt-1 mb-8">
                            <div class="mb-6">
                                <h1 class="text-xl"><i class="el-icon-unlock mr-2"></i>Aanmelden</h1>
                            </div>

                            <!-- alert -->
                            <el-alert v-if="error" title="Ongeldige gebruiker en/of wachtwoord!" type="error"
                                      effect="dark" :closable="false" show-icon class="mb-4"></el-alert>

                            <!-- form -->
                            <el-form :model="loginForm" ref="loginForm" :rules="rules" :show-message="false">
                                <el-form-item prop="userName">
                                    <el-input placeholder="Email adres" v-model="loginForm.userName"
                                              prefix-icon="el-icon-message"></el-input>
                                </el-form-item>

                                <el-form-item prop="password">
                                    <el-input placeholder="Wachtwoord" v-model="loginForm.password" show-password
                                              prefix-icon="el-icon-key"></el-input>
                                    <div class="w-full text-right sp-label">
                                        <router-link :to="{ path: 'recover'}"><span
                                                class="text-xs text-gray-400 cursor-pointer hover:text-primary">wachtwoord vergeten?</span>
                                        </router-link>
                                    </div>
                                </el-form-item>
                            </el-form>
                        </div>

                        <div class="flex justify-center m-4">
                            <el-button type="primary" @click="submitForm('loginForm')" :loading="loading">Inloggen<i
                                    class="ml-2 el-icon-right"></i></el-button>
                        </div>
                    </el-card>
                    <div class="flex float-right">
                        <a class="social-badge mr-2" href="https://www.instagram.com/orcabilzen/">
                            <img src="../assets/instagram-brands.svg" width="20" height="20" class="text-white"/>
                        </a>

                        <a class="social-badge" href="https://www.facebook.com/OrcaBilzen/">
                            <img src="../assets/facebook-f-brands.svg" width="15" height="15"/>
                        </a>
                    </div>
                </div>
            </div>

            <div class="w-full absolute">
                <header class="orc-vert-limit-header">
                    <div class="flex justify-between mt-4">
                        <!-- Logo -->
                        <router-link :to="{ path: 'home'}">
                            <div class="logo orc-strong">
                                ORCA
                            </div>
                        </router-link>
                    </div>
                </header>
            </div>
        </div>
    </el-container>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                loginForm: {
                    userName: "",
                    password: ""
                },

                dialogVisible: true,
                loading: false,
                error: false,

                // Rules
                rules: {
                    userName: [
                        {type: 'email', required: true, message: 'Vul een gebruikersnaam in', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: 'Vul een wachtwoord in', trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.login()
                    } else {
                        return false;
                    }
                });
            },
            login() {
                this.error = false
                let username = this.loginForm.userName
                let password = this.loginForm.password
                this.$store.dispatch('login', {username, password})
                    .then(() => {
                        console.log('dispatch login')
                        this.loading = false
                        this.$router.push('Home');
                    })
                    .catch(err => {
                        this.loading = false
                        this.error = true
                    })
            }
        }
    }
</script>

<style scoped>
    .login-dialog {
        width: 400px;
    }

    .sp-label {
        margin-top: -5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue